export default __webpack_public_path__ + "static/media/credit-empty.a65bc8e2.svg";